export default __webpack_public_path__ + "images/770b55e732331604cbf3796cb118856d.svg";